import { z } from 'zod/v4';

export const SubscriptionTier = z.enum(['free', 'premium']);
export type SubscriptionTier = z.infer<typeof SubscriptionTier>;

export const UserSchema = z.object({
  id: z.string(),
  clerkId: z.string(),
  email: z.email(),
  subscriptionTier: SubscriptionTier,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type User = z.infer<typeof UserSchema>;

export const CreateUserSchema = UserSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateUser = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = UserSchema.partial().omit({
  id: true,
  clerkId: true,
  createdAt: true,
});

export type UpdateUser = z.infer<typeof UpdateUserSchema>;
